import { render, staticRenderFns } from "./driver-detail-driver-info.vue?vue&type=template&id=a83caa9e&scoped=true"
import script from "./driver-detail-driver-info.vue?vue&type=script&lang=js"
export * from "./driver-detail-driver-info.vue?vue&type=script&lang=js"
import style0 from "./driver-detail-driver-info.vue?vue&type=style&index=0&id=a83caa9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83caa9e",
  null
  
)

export default component.exports